import { useAuth } from '@platform/auth-client';
import { useTranslation } from '@platform/i18n';
import type { TypedClient } from '@platform/openapi';
import { useTenantDetail } from '../features/catalog/useCatalogQueries.ts';
import { shopDetailOf } from '../features/shop-detail.ts';
import type { ShopIdentity } from './TenantSwitcher.tsx';

export const useShopIdentity = (api: TypedClient): ShopIdentity => {
  const { t, i18n } = useTranslation();
  const slug = useAuth().user?.tenantSlug;
  const tenant = useTenantDetail(api).data;
  return tenant === undefined
    ? { name: slug ?? t('shell.tenant'), detail: null }
    : { name: tenant.name, detail: shopDetailOf(tenant, i18n.language) };
};
